import React, { useState, useEffect } from 'react';
import ProfileTab from './ProfileTab';
import StartupTab from './StartupTab';
import CoFounderTab from './CoFounderTab';
import ActivityTab from './ActivityTab';
import ReportTab from './ReportTab';
import AdminHistoryTab from './AdminHistoryTab';
import Billing from './Billing';
import VCTab from './VCTab';
import TeamTab from './Team';
import AcceleratorTab from './AcceleratorTab';
import { updateUserDetailApi } from '../../api/usersApi';

const RenderTab = ({ selectedUser, profileData, startupData, coFounderData, getAngel, setEdit, handleActionUser, isSuspendLoading, userActivity, reportList, setSelectUser, setPersonalEmail, personalEmail, handleUpdateUser, isSaveLoading, setIsSaveLoading, registedEmail, setRegistedEmail, handleUpdateTeamUser, setReason, reason, LazyImage, adminHistory, isEditUser }) => {
  const [activePage, setActivePage] = useState('Profile');

  useEffect(() => {
    setActivePage('Profile');
  }, [selectedUser]);

  const ProfileTabs = [
    { name: 'Profile' },
    ...(profileData?.type === 2
      ? [
        { name: 'Activity' },
        { name: 'Billing' },
        { name: 'Reports' },
      ]
      : profileData?.type === 3
        ? [
          { name: 'VC' },
          { name: 'Team' },
          { name: 'Activity' },
          { name: 'Reports' },
          { name: 'Billing' },
        ]
        : profileData?.type === 4
          ? [
            { name: 'Accelerator' },
            { name: 'Team' },
            { name: 'Activity' },
            { name: 'Reports' },
            { name: 'Billing' },
          ]
          : [
            { name: 'Co-Founders' },
            { name: 'Startup' },
            { name: 'Activity' },
            { name: 'Reports' },
          ]),
    { name: 'Admin History' },
  ];

  const renderActiveTab = () => {
    switch (activePage) {
      case 'Profile':
        return <ProfileTab
          profileData={profileData}
          setEdit={setEdit}
          handleActionUser={handleActionUser}
          isSuspendLoading={isSuspendLoading}
          setSelectUser={setSelectUser}
          setPersonalEmail={setPersonalEmail}
          personalEmail={personalEmail}
          handleUpdateUser={handleUpdateUser}
          isSaveLoading={isSaveLoading}
          setIsSaveLoading={setIsSaveLoading}
          setRegistedEmail={setRegistedEmail}
          registedEmail={registedEmail}
          reason={reason}
          setReason={setReason}
          LazyImage={LazyImage}
          isEditUser={isEditUser}
        />;
      case 'Billing':
        return (profileData?.type === 2 || profileData?.type === 3 || profileData?.type === 4) && <Billing getAngel={getAngel} />;
      case 'Co-Founders':
        return profileData?.type === 1 && <CoFounderTab coFounderData={coFounderData} />;
      case 'VC':
        return profileData?.type === 3 && <VCTab startupData={startupData} />;
      case 'Team':
        return (profileData?.type === 3 || profileData?.type === 4) &&
          <TeamTab
            setEdit={setEdit}
            teamData={coFounderData}
            setSelectUser={setSelectUser}
            handleUpdateTeamUser={handleUpdateTeamUser}
            isSaveLoading={isSaveLoading}
            setIsSaveLoading={setIsSaveLoading}
            handleActionUser={handleActionUser}
            isSuspendLoading={isSuspendLoading}
            LazyImage={LazyImage}
          />;
      case 'Startup':
        return profileData?.type === 1 && <StartupTab selectedUser={selectedUser} startupData={startupData} />;
      case 'Accelerator':
        return profileData?.type === 4 && <AcceleratorTab acceleratorData={startupData} />;
      case 'Activity':
        return <ActivityTab userActivity={userActivity} />;
      case 'Reports':
        return <ReportTab reportList={reportList} />;
      case 'Admin History':
        return <AdminHistoryTab adminHistory={adminHistory} />;
      default:
        return null;
    }
  };
  return (
    <>
      < div className='founder-tabs'>
        <div className="profile-tabs">
          {ProfileTabs?.map((tab, index) => (
            <span
              key={index}
              className={`profile-tab-item ${activePage === tab?.name ? "active" : ""
                }`}
              onClick={() => setActivePage(tab?.name)}
            >
              {tab?.name}
            </span>
          ))}
        </div>
      </div>
      <div className="founder-tab-content">
        {renderActiveTab()}
      </div>
    </>
  )
}

export default RenderTab
